<div class="imprint">
  <div class="header">
    <h2 class="main-header">Impressum</h2>
    <h2 class="section-header">
      Angaben gem. § 5 Digitale-Dienste-Gesetz (DDG)
    </h2>
    <h2 class="section-header">
      BIMSWARM ist eine Plattform der BIMSWARM GmbH
    </h2>
  </div>
  <div class="content">
    <div class="section">
      <h3 class="sub-header">Anschrift</h3>
      <div class="normal-text address">
        <div>Geneststraße 5 / Aufgang A</div>
        <div>10829 Berlin</div>
        <div>Telefon: + 49 30 92108778 0</div>
        <div>
          E-Mail: <a href="mailto:info@bimswarm.de">info@bimswarm.de</a>
        </div>
        <div>Amtsgericht Berlin Charlottenburg HRB 278854 B</div>
        <div>USt.-Id.-Nummer DE457123324</div>
        <div>
          Die BIMSWARM GmbH ist eine Gesellschaft mit beschränkter Haftung nach
          Maßgabe des GmbHGesetzes mit Sitz in Berlin.
        </div>
      </div>
    </div>
    <div class="section">
      <h2 class="section-header">Vertretungsberechtigte / Geschäftsführung</h2>
      <div class="normal-text"><span>Dr. Jan Tulke</span></div>
    </div>
    <div class="section">
      <h3 class="sub-header">EU-Streitschlichtung</h3>
      <div class="normal-text">
        <span>
          Diese Plattform richtet sich ausschließlich an Unternehmer im Sinne
          von § 14 BGB. Wir sind daher nicht nach Art. 14 Abs. 1 der Verordnung
          (EU) 524/2013 über Online-Streitbeilegung in
          Verbraucherangelegenheiten (ODR-Verordnung) gesetzlich verpflichtet,
          Sie auf die Europäische Online-Streitbeilegungs-Plattform
          (OS-Plattform) hinzuweisen.
        </span>
      </div>
    </div>
    <div class="section">
      <h3 class="sub-header">Haftung</h3>
      <div class="normal-text">
        <span>
          Wir sind für die Inhalte unserer Internetseiten nach den Maßgaben der
          allgemeinen Gesetze verantwortlich. Alle Inhalte werden mit der
          gebotenen Sorgfalt und nach bestem Wissen erstellt und dienen
          lediglich rein informativen Zwecken. Soweit wir auf unseren
          Internetseiten mittels Hyperlink auf Internetseiten Dritter verweisen,
          können wir keine Gewähr für die fortwährende Aktualität, Richtigkeit
          und Vollständigkeit der verlinkten Inhalte übernehmen, da diese
          Inhalte außerhalb unseres Verantwortungsbereichs liegen und wir auf
          die zukünftige Gestaltung keinen Einfluss haben. Sollten aus Ihrer
          Sicht Inhalte gegen geltendes Recht verstoßen oder unangemessen sein,
          teilen Sie uns dies bitte mit. Die rechtlichen Hinweise auf dieser
          Seite sowie alle Fragen und Streitigkeiten im Zusammenhang mit der
          Gestaltung dieser Internetseite unterliegen dem Recht der
          Bundesrepublik Deutschland.
        </span>
      </div>
    </div>
    <div class="section">
      <h3 class="sub-header">Urheberrechtshinweis</h3>
      <div class="normal-text">
        <span>
          Die auf unserer Internetseite vorhandenen Texte, Bilder, Fotos, Videos
          oder Grafiken unterliegen in der Regel dem Schutz des Urheberrechts.
          Jede unberechtigte Verwendung (insbesondere die Vervielfältigung,
          Bearbeitung oder Verbreitung) dieser urheberrechtsgeschützten Inhalte
          ist daher untersagt. Wenn Sie beabsichtigen, diese Inhalte oder Teile
          davon zu verwenden, kontaktieren Sie uns bitte im Voraus unter den
          oben stehenden Angaben. Soweit wir nicht selbst Inhaber der benötigten
          urheberrechtlichen Nutzungsrechte sein sollten, bemühen wir uns, einen
          Kontakt zum Berechtigten zu vermitteln.
        </span>
      </div>
    </div>
    <div class="section">
      <h3 class="sub-header">Angaben nach dem Digital Services Act (DSA)</h3>
      <h3 class="sub-header">Kontaktstelle für Behörden gem. Art 11 DSA:</h3>
      <div class="normal-text">
        <span>
          Zentrale Kontaktstelle nach Art. 11 DSA für die direkte Kommunikation
          mit den Behörden der Mitgliedstaaten, der Kommission, und dem
          Europäischen Ausschuss für digitale Dienste im Zusammenhang mit der
          Anwendung der DSA ist:
        </span>
        <div class="spacer-top">Telefon: + 49 30 92108778 0</div>
        <div class="spacer-top">
          E-Mail: <a href="mailto:info@bimswarm.de">info@bimswarm.de</a>
        </div>
        <div class="spacer-block">
          Für die Kommunikation mit der Kontaktstelle ist Englisch oder Deutsch
          die bevorzugte Sprache.
        </div>
      </div>
    </div>
    <div class="section">
      <h3 class="sub-header">
        Kontaktstelle für Anbieter und Nutzer gem. Art 12 DSA:
      </h3>
      <div class="normal-text">
        <span>
          Zentrale Kontaktstelle nach Art. 12 DSA für die direkte Kommunikation
          mit den Anbietern und Nutzern im Zusammenhang mit der Anwendung der
          DSA ist:
        </span>
        <div class="spacer-top">Telefon: + 49 30 92108778 0</div>
        <div class="spacer-top">
          E-Mail:
          <a href="mailto:customersuccess@bimswarm.de"
            >customersuccess@bimswarm.de</a
          >
        </div>
      </div>
    </div>
    <div class="section">
      <h3 class="sub-header">
        Für von uns erbrachte Leistungen gelten unsere AGB. Sie finden sie unter
        <a routerLink="/agb">AGB</a>
      </h3>
    </div>
  </div>
</div>
